import { FileText, Layers, LayoutDashboard, Users } from 'lucide-react';

// Configuration centralisée des liens par rôle
const sidebarConfig = {
  admin: [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, link: '/admin' },
    { id: 'users', label: 'Mes Gestionnaires', icon: Users, link: '/admin/utilisateurs' },
    { id: 'surveys', label: 'Gestion Sondage', icon: FileText, link: '/admin/gestion-sondage' },
    { id: 'journalisation', label: 'Journalisation', icon: LayoutDashboard, link: '/admin/journalisation' },
    // { id: 'stats', label: 'Statistiques globales', icon: LayoutDashboard, link: '/admin/statistiques' },
  ],
  gerant: [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, link: '/gerant/dashboard' },
    { id: 'surveys', label: 'Mes sondages', icon: FileText, link: '/gerant/gestion-sondages' },
    // { id: 'participants', label: 'Participants', icon: Users, link: '/gerant/participants' },
    { id: 'models', label: 'Modèles', icon: Layers, link: '/gerant/modeles-sondages' },
  ],
  participant: [
    { id: 'surveys', label: 'Mes sondages', icon: FileText, link: '/participant/surveys' },
    { id: 'history', label: 'Historique', icon: LayoutDashboard, link: '/participant/history' },
  ],
};

export function useSidebarConfig(userRole) {
  // Normaliser le rôle
  const normalizedRole = userRole === 'client' ? 'participant' : userRole;
  return sidebarConfig[normalizedRole] || [];
}

export function isActiveLink(link, pathname) {
  if (link === '/admin' || link === '/gerant/dashboard' || link === '/participant/surveys') {
    return pathname === link;
  }
  return pathname.startsWith(link);
}
